import { Grid } from "@material-ui/core";
import { InputTextMaster } from "App/Component/ui";
import MasterButton from "App/Component/ui/button/MasterButton";
import Modal from "App/Component/ui/Modal/Modal";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance4,
} from "App/constants";
import {
  convertToValidPrice,
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
} from "App/utils/helpers";
import { useState } from "react";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";

export const urlGet = LIST_URL_WAREHOUSE.daftarInventoryControl.get;
export const urlDelete = LIST_URL_WAREHOUSE.pembelianPBF.delete;
export const urlUpdateOQ = "/wmsfarmasi/inventory/update-oq";

export const RESET_STATE_FORM_FILTER = {
  pages: 1,
  limit: 10,
  barang_name: "",
  gudang: "Pilih Gudang",
  gudang_id: "",
  reload: false,
};

export const RESET_STATE_BARANG = {
  id: null,
  name: "",
  oq: 0,
  periode: 0,
  rata_rata: 0,
  stok_min: 0,
  stok_max: 0,
};

export const getByFilterInventory = async (formFilter, pages, limit) => {
  try {
    const api = await instance4.post(urlGet, {
      halaman: pages,
      jumlah: limit,
      barang_name: formFilter.barang_name,
      gudang_id: formFilter.gudang_id,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID INVENTORY",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "barang_id",
    disablePadding: false,
    label: "ID BARANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "namaBarang",
    disablePadding: false,
    label: "NAMA BARANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "namaGudang",
    disablePadding: false,
    label: "GUDANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "hargapokok",
    disablePadding: false,
    label: "HARGA POKOK",
    align: "left",
    minWidth: "150px",
  },

  {
    id: "qty",
    disablePadding: false,
    label: "JML STOK",
    align: "left",
    sort: false,
    minWidth: "150px",
  },

  {
    id: "persediaan",
    disablePadding: false,
    label: "PERSEDIAAN",
    align: "left",
    sort: false,
    minWidth: "150px",
  },

  {
    id: "stockmin",
    disablePadding: false,
    label: "STOCK MIN",
    align: "left",
    sort: false,
    minWidth: "100px",
  },

  {
    id: "stockmax",
    disablePadding: false,
    label: "STOCK MAX",
    align: "left",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "rata_rata",
    disablePadding: false,
    label: "RATA - RATA",
    align: "left",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "oq",
    disablePadding: false,
    label: "ORDER QUANTITY",
    align: "left",
    sort: false,
    minWidth: "130px",
  },
  {
    id: "periode",
    disablePadding: false,
    label: "PERIODE",
    align: "left",
    sort: false,
    minWidth: "100px",
  },
  // {
  //   id: "nilaikritis",
  //   disablePadding: false,
  //   label: "STOCK KRITIS",
  //   align: "left",
  //   sort: false,
  //   minWidth: "100px",
  // },

  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const deleteInventoryControlByID = async (id) => {
  try {
    const res = await instance4.post(
      LIST_URL_WAREHOUSE.daftarInventoryControl.delete,
      {
        id,
      }
    );

    if (res.data.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus data",
      };
    } else {
      return {
        state: false,
        message: res.data.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const ModalEditOQ = ({
  setShowModal,
  formBarang,
  setFormBarang,
  setNewData,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const handleChange = (text) => (e) => {
    setFormBarang({
      ...formBarang,
      [text]: formatRupiah(e.target.value),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      if (formBarang.id === "") {
        defaultToastError("Barang tidak boleh kosong!");
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      } else {
        const api = await instance4.post(urlUpdateOQ, {
          id: formBarang.id,
          oq: parseInt(convertToValidPrice(formBarang.oq)),
          periode: parseInt(convertToValidPrice(formBarang.periode)),
          rata_rata: parseInt(convertToValidPrice(formBarang.rata_rata)),
          stok_min: parseInt(convertToValidPrice(formBarang.stok_min)),
          stok_max: parseInt(convertToValidPrice(formBarang.stok_max)),
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          await setNewData();
        } else {
          defaultToastError(res.message);
        }
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      }
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError(error?.response?.data?.message);
    }
  };

  return (
    <Modal title={`Ubah Data Order Quantity `} show={setShowModal} width='60%'>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <p className='mt-1 mb-1'>{formBarang.name}</p>
        <Grid container spacing={1}>
          <InputTextMaster
            type='hidden'
            name='id'
            id='id'
            readOnly={true}
            value={formBarang.id}
          />
          <Grid item sm={4}>
            <InputTextMaster
              name='stok_min'
              label='STOK MINIMUM'
              id='stok_min'
              value={formBarang.stok_min}
              onChange={handleChange("stok_min")}
              placeholder='Stok Minimum'
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name='stok_max'
              label='STOK MAKSIMAL'
              id='stok_max'
              value={formBarang.stok_max}
              onChange={handleChange("stok_max")}
              placeholder='Stok Maksimal'
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name='rata_rata'
              label='RATA - RATA'
              id='rata_rata'
              value={formBarang.rata_rata}
              onChange={handleChange("rata_rata")}
              placeholder='Rata - Rata'
            />
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name='periode'
              label='PERIODE STOK'
              id='periode'
              value={formBarang.periode}
              onChange={handleChange("periode")}
              placeholder='Periode Order'
              withButton={true}>
              <button
                type={"button"}
                onClick={null}
                style={{
                  borderRight: "1px solid #EAEAEA",
                  borderTop: "1px solid #EAEAEA",
                  borderBottom: "1px solid #EAEAEA",
                  borderLeft: "0",
                  background: "#fff",
                  padding: "0 0.8rem",
                  cursor: "pointer",
                  borderRadius: "0 6px 6px 0",
                }}>
                Hari
              </button>
            </InputTextMaster>
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name='oq'
              label='ORDER QUANTITY'
              id='oq'
              value={formBarang.oq}
              onChange={handleChange("oq")}
              placeholder='Order Quantity'
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            disabled={disabled.state}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};
